module.exports = __webpack_public_path__ + "img/w35b.1f4d9c90.jpg";